module.exports = __webpack_public_path__ + "static/media/screen-location-center.13d5088a.svg";